/**
 * ResumeCard Component
 * 
 * Prominent CTA to resume last incomplete drill
 */

import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PlayCircle } from 'lucide-react';
import type { ResumeDrill } from '@/services/dashboard-progress';
import { formatDistanceToNow } from 'date-fns';

interface ResumeCardProps {
  drill: ResumeDrill;
}

export function ResumeCard({ drill }: ResumeCardProps) {
  const formattedDate = formatDistanceToNow(new Date(drill.last_attempt_date), {
    addSuffix: true,
  });

  return (
    <Card className="bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200 mb-6">
      <CardContent className="p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-start gap-4 flex-1">
            <div className="p-3 bg-blue-100 rounded-full">
              <PlayCircle className="w-6 h-6 text-blue-600" aria-hidden="true" />
            </div>
            <div className="flex-1">
              <h2 className="text-sm font-medium text-blue-900 mb-1">
                Continue where you left off
              </h2>
              <h3 className="text-lg font-bold text-gray-900 mb-1">
                {drill.title}
              </h3>
              <p className="text-sm text-gray-600">
                {drill.progress}% complete • Last practiced {formattedDate}
              </p>
            </div>
          </div>
          <Link to={`/drills/${drill.drill_id}`}>
            <Button size="lg" className="flex-shrink-0">
              Resume Drill
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}

